import { match } from 'ts-pattern';
import { implementCustomExpressions } from '../__generated/implementation.js';
import { ApplicationTypes, round } from '../index.js';
export const cornerFillerExpressions = implementCustomExpressions({
    CornerFiller: {
        $cornerFillerActive: (s)=>{
            return match(s.$room.shape).with('I', ()=>false).with('L', ()=>s.cornerFillerType === 'AB').with('U', ()=>true).exhaustive();
        },
        $cornerCabinetExtraWidth: (s)=>s.$width - s.$room.$minCabinetDepth,
        // TODO: Should we also check if some cabinet is close enough to have the corner??
        $cornerFillerFilter: (s)=>{
            if (!s.$cornerFillerActive) {
                return false;
            }
            return {
                navigationStates: [
                    ApplicationTypes.NavigationState.Room,
                    ApplicationTypes.NavigationState.RoomContent,
                    ApplicationTypes.NavigationState.Recipes,
                    ApplicationTypes.NavigationState.Summary,
                    ApplicationTypes.NavigationState.Finalize,
                    ApplicationTypes.NavigationState.FinalizeGlamour
                ]
            };
        },
        $cornerFillerCountertopFilter: (s)=>{
            if (s.$cornerFillerFilter === false) {
                return false;
            }
            return {
                navigationStates: [
                    ApplicationTypes.NavigationState.Room,
                    ApplicationTypes.NavigationState.RoomContent,
                    ApplicationTypes.NavigationState.Recipes
                ]
            };
        },
        // It looks better with slight offset (+- 5)
        $offsetX: (s)=>{
            return match(s.cornerFillerType).with('AB', ()=>-s.$room.$width / 2 + s.$room.$wallA.$maxWallItemDepth).with('BC', ()=>s.$room.$width / 2 - s.$room.$wallC.$maxWallItemDepth).exhaustive();
        },
        $offsetY: ()=>0,
        // It looks better with slight offset (+- 5)
        $offsetZ: (s)=>{
            return match(s.cornerFillerType).with('AB', ()=>-s.$room.$depth / 2 + s.$room.$wallB.$maxWallItemDepth).with('BC', ()=>-s.$room.$depth / 2 + s.$room.$wallB.$maxWallItemDepth).exhaustive();
        },
        $rotation: (s)=>{
            return match(s.cornerFillerType).with('AB', ()=>Math.PI / 2).with('BC', ()=>0).exhaustive();
        },
        $netWidth: (s)=>s.$room.$cornerCabinetWidth,
        $width: (s)=>round(s.$netWidth + s.$room.$cabinetSideGap, 4),
        $wallCornerOffsetX: (s)=>{
            return match(s.cornerFillerType).with('AB', ()=>-s.$room.$width / 2 - s.$wallCornerThickness).with('BC', ()=>s.$room.$width / 2).exhaustive();
        },
        $wallCornerOffsetZ: (s)=>{
            return match(s.cornerFillerType).with('AB', ()=>-s.$room.$depth / 2).with('BC', ()=>-s.$room.$depth / 2).exhaustive();
        },
        $wallCornerHeight: (s)=>{
            return s.$room.$wallB.$height;
        },
        // +5 so there is small overlap between countertops next to each other
        $modelSizeOffset: (s)=>{
            return s.$cornerCabinetExtraWidth - s.$countertopOffsetZ;
        },
        $countertopPartOneOffsetX: (s)=>{
            return match(s.cornerFillerType).with('AB', ()=>s.$countertopPartOneWidth / 2 - 45).with('BC', ()=>s.$countertopPartOneWidth / 2 - s.$cornerCabinetExtraWidth).exhaustive();
        },
        $countertopPartOneOffsetZ: (s)=>{
            return match(s.cornerFillerType).with('AB', ()=>s.$modelSizeOffset + 5).with('BC', ()=>0).exhaustive();
        },
        $countertopPartOneWidth: (s)=>{
            return match(s.cornerFillerType).with('AB', ()=>s.$room.$wallA.$maxWallItemDepth + s.$countertopOffsetZ + (s.$backPanelPartTwoFilter ? s.$room.$backPanelDepth : 0)).with('BC', ()=>s.$width + (s.$backPanelPartTwoFilter ? s.$room.$backPanelDepth : 0)).exhaustive();
        },
        $countertopPartOneDepth: (s)=>{
            const baseDepth = match(s.cornerFillerType).with('AB', ()=>s.$width + (s.$backPanelPartOneFilter ? s.$room.$backPanelDepth : 0) + 5).with('BC', ()=>s.$room.$wallB.$maxWallItemDepth + s.$countertopOffsetZ + (s.$backPanelPartOneFilter ? s.$room.$backPanelDepth : 0)).exhaustive();
            return baseDepth;
        },
        $countertopPartTwoOffsetX: (s)=>{
            return match(s.cornerFillerType).with('AB', ()=>-s.$modelSizeOffset - 9).with('BC', ()=>(s.$countertopPartTwoWidth - s.$modelSizeOffset) / 2 - 9).exhaustive();
        },
        $countertopPartTwoOffsetZ: (s)=>{
            return match(s.cornerFillerType).with('AB', ()=>0).with('BC', ()=>s.$cornerCabinetExtraWidth - s.$room.$doorThickness - 10).exhaustive();
        },
        $countertopPartTwoWidth: (s)=>{
            return match(s.cornerFillerType).with('AB', ()=>s.$modelSizeOffset).with('BC', ()=>s.$room.$wallC.$maxWallItemDepth + s.$countertopOffsetZ + (s.$backPanelPartTwoFilter ? s.$room.$backPanelDepth : 0)).exhaustive();
        },
        $countertopPartTwoDepth: (s)=>{
            const baseDepth = match(s.cornerFillerType).with('AB', ()=>s.$room.$wallB.$maxWallItemDepth + s.$countertopOffsetZ + (s.$backPanelPartOneFilter ? s.$room.$backPanelDepth : 0)).with('BC', ()=>s.$room.$wallB.$maxWallItemDepth + s.$countertopOffsetZ + s.$modelSizeOffset).exhaustive();
            return baseDepth;
        },
        $backPanelPartOneOffsetX: (s)=>{
            return match(s.cornerFillerType).with('AB', ()=>-s.$cornerCabinetExtraWidth + s.$room.$backPanelDepth - 0.3 * 25.4).with('BC', ()=>-s.$cornerCabinetExtraWidth - 0.3 * 25.4).exhaustive();
        },
        $backPanelPartTwoOffsetX: (s)=>{
            return match(s.cornerFillerType).with('AB', ()=>s.$room.$wallB.$maxWallItemDepth - 0.3 * 25.4).with('BC', ()=>s.$room.$minCabinetDepth + s.$room.$backPanelDepth - 0.3 * 25.4).exhaustive();
        },
        // TODO: This might be off - an extra offset is needed
        // to aligh it perfectly with the side panel.
        $backPanelPartOneOffsetZ: (s)=>{
            return match(s.cornerFillerType).with('AB', ()=>-s.$room.$wallA.$maxWallItemDepth + 0.3 * 25.4).with('BC', ()=>-s.$room.$wallA.$maxWallItemDepth + 0.3 * 25.4).exhaustive();
        },
        $backPanelPartTwoOffsetZ: (s)=>{
            return match(s.cornerFillerType).with('AB', ()=>-s.$room.$minCabinetDepth).with('BC', ()=>s.$cornerCabinetExtraWidth).exhaustive();
        },
        $backPanelPartOneRotationY: (s)=>{
            return match(s.cornerFillerType).with('AB', ()=>0).with('BC', ()=>0).exhaustive();
        },
        $backPanelPartTwoRotationY: (s)=>{
            return match(s.cornerFillerType).with('AB', ()=>-Math.PI / 2).with('BC', ()=>Math.PI / 2).exhaustive();
        },
        $backPanelPartOneWidth: (s)=>{
            return match(s.cornerFillerType).with('AB', ()=>s.$room.$wallB.$maxWallItemDepth + s.$room.$cornerFillerExtraSpace).with('BC', ()=>s.$room.$wallC.$maxWallItemDepth + s.$room.$cornerFillerExtraSpace + s.$room.$backPanelDepth - 0.3 * 25.4).exhaustive();
        },
        $backPanelPartTwoWidth: (s)=>{
            return match(s.cornerFillerType).with('AB', ()=>s.$width).with('BC', ()=>s.$room.$wallB.$maxWallItemDepth + s.$room.$cornerFillerExtraSpace + (s.$backPanelPartOneFilter ? s.$room.$backPanelDepth : 0)).exhaustive();
        },
        $backPanelPartOneFilter: (s)=>{
            if (!s.$cornerFillerFilter) {
                return false;
            }
            if (s.cornerFillerType === 'AB' && s.$room.$wallA.$active && !s.$room.$wallA.fullHeight) {
                return true;
            }
            if (s.cornerFillerType === 'BC' && s.$room.$wallB.$active && !s.$room.$wallB.fullHeight) {
                return true;
            }
            return false;
        },
        $backPanelPartTwoFilter: (s)=>{
            if (!s.$cornerFillerFilter) {
                return false;
            }
            if (s.cornerFillerType === 'AB' && s.$room.$wallB.$active && !s.$room.$wallB.fullHeight) {
                return true;
            }
            if (s.cornerFillerType === 'BC' && s.$room.$wallC.$active && !s.$room.$wallC.fullHeight) {
                return true;
            }
            return false;
        },
        $toeKickPartOneWidth: (s)=>{
            return match(s.cornerFillerType).with('AB', ()=>s.$width - s.$toeKickInset).with('BC', ()=>s.$width - s.$toeKickInset).exhaustive();
        },
        $toeKickPartTwoWidth: (s)=>{
            return match(s.cornerFillerType).with('AB', ()=>s.$width - s.$toeKickInset).with('BC', ()=>s.$width - s.$toeKickInset).exhaustive();
        },
        $toeKickPartOneDepth: (s)=>{
            return match(s.cornerFillerType).with('AB', ()=>s.$room.$minCabinetDepth - 2 * s.$toeKickInset + s.$room.$doorThickness).with('BC', ()=>s.$room.$minCabinetDepth - 2 * s.$toeKickInset + s.$room.$doorThickness).exhaustive();
        },
        $toeKickPartTwoDepth: (s)=>{
            return match(s.cornerFillerType).with('AB', ()=>s.$room.$minCabinetDepth - 2 * s.$toeKickInset + s.$room.$doorThickness).with('BC', ()=>s.$room.$minCabinetDepth - 2 * s.$toeKickInset + s.$room.$doorThickness).exhaustive();
        },
        $toeKickPartOneOffsetX: (s)=>{
            return match(s.cornerFillerType).with('AB', ()=>s.$room.$minCabinetDepth - s.$toeKickInset).with('BC', ()=>s.$toeKickInset - s.$room.$doorThickness).exhaustive();
        },
        $toeKickPartTwoOffsetX: (s)=>{
            return match(s.cornerFillerType).with('AB', ()=>s.$toeKickInset - s.$room.$doorThickness).with('BC', ()=>s.$room.$minCabinetDepth - s.$toeKickInset).exhaustive();
        },
        $toeKickPartOneOffsetZ: (s)=>{
            return match(s.cornerFillerType).with('AB', ()=>-s.$room.$minCabinetDepth + s.$toeKickInset).with('BC', ()=>-s.$room.$minCabinetDepth + s.$toeKickInset).exhaustive();
        },
        $toeKickPartTwoOffsetZ: (s)=>{
            return match(s.cornerFillerType).with('AB', ()=>-s.$room.$minCabinetDepth + s.$toeKickInset).with('BC', ()=>-s.$room.$minCabinetDepth + s.$toeKickInset).exhaustive();
        },
        $toeKickPartOneRotationY: (s)=>{
            return match(s.cornerFillerType).with('AB', ()=>Math.PI).with('BC', ()=>-Math.PI / 2).exhaustive();
        },
        $toeKickPartTwoRotationY: (s)=>{
            return match(s.cornerFillerType).with('AB', ()=>-Math.PI / 2).with('BC', ()=>Math.PI).exhaustive();
        }
    }
});

//# sourceMappingURL=corner-filler.js.map